import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  TextField,
  IconButton,
  Paper,
  Divider,
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DnsIcon from '@mui/icons-material/Dns';
import { toast } from 'react-toastify';

export default function DnsInfoDialog({ onClose, deployment }) {
  const handleCopyToClipboard = (text, label) => {
    navigator.clipboard.writeText(text);
    toast.success(`${label} in die Zwischenablage kopiert`);
  };

  return (
    <Dialog open={true} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ pb: 1 }}>
        <Box display="flex" alignItems="center" gap={1}>
          <DnsIcon color="primary" />
          <Typography variant="h6">DNS Konfiguration</Typography>
        </Box>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Typography variant="body1" color="text.secondary" paragraph>
          Fügen Sie bitte den folgenden CNAME-Eintrag in Ihrem DNS-Anbieter
          hinzu, um Ihre Domain mit diesem Deployment zu verbinden. Dieser
          Eintrag ermöglicht es, dass Ihre Domain auf die
          CloudFront-Distribution verweist, die für dieses Deployment erstellt
          wurde.
        </Typography>
        <Paper
          variant="outlined"
          sx={{
            p: 3,
            backgroundColor: 'background.default',
            border: '1px solid',
            borderColor: 'divider',
          }}
        >
          {' '}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <Box>
              <Typography variant="subtitle2" color="primary" gutterBottom>
                Typ
              </Typography>
              <TextField
                fullWidth
                value="CNAME"
                InputProps={{
                  readOnly: true,
                  sx: { backgroundColor: 'background.paper' },
                }}
              />
            </Box>

            <Box>
              <Typography variant="subtitle2" color="primary" gutterBottom>
                Name
              </Typography>
              <Box display="flex" gap={1}>
                <TextField
                  fullWidth
                  value={deployment?.domain || ''}
                  InputProps={{
                    readOnly: true,
                    sx: { backgroundColor: 'background.paper' },
                  }}
                />
                <IconButton
                  onClick={() =>
                    handleCopyToClipboard(deployment?.domain, 'Domain')
                  }
                  color="primary"
                >
                  <ContentCopyIcon />
                </IconButton>
              </Box>
            </Box>

            <Box>
              <Typography variant="subtitle2" color="primary" gutterBottom>
                Wert
              </Typography>
              <Box display="flex" gap={1}>
                <TextField
                  fullWidth
                  value={deployment?.cloudfrontDomainName || ''}
                  InputProps={{
                    readOnly: true,
                    sx: { backgroundColor: 'background.paper' },
                  }}
                />
                <IconButton
                  onClick={() =>
                    handleCopyToClipboard(
                      deployment?.cloudfrontDomainName,
                      'CloudFront Domain',
                    )
                  }
                  color="primary"
                >
                  <ContentCopyIcon />
                </IconButton>
              </Box>
            </Box>
          </Box>
        </Paper>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} variant="outlined" sx={{ px: 3 }}>
          Schließen
        </Button>
      </DialogActions>
    </Dialog>
  );
}
